<template>
  <div class="flash-sale">
    <div class="flash-title">
      <strong>限时抢购</strong>
      <span
        v-if="remainTime > 0"
        class="all"
        @click="goFlashSaleList">查看全部<i class="iconfont icon-xiangzuo1"></i>
      </span>
    </div>
    <mt-swipe
      :auto="10000"
      :show-indicators="false"
      :stopPropagation="true">
        <mt-swipe-item v-for="(items, key) in dataList" :key="key" @touchmove.native.stop.prevent>
          <div :class="['flash-sale-list', items.length === 4 ? 'sp-between' : '']">
            <div
              class="flash-sale-item"
              v-for="(item, index) in items" :key="index"
              @click="entoDetailPage(item.ProductId)">
                <div class="flash-img">
                  <img v-lazy="item.ShowPicUrl" alt=""/>
                  <div class="soldout-mask" v-if="!item.StockCount">
                    <p>Sorry</p>
                    <p>抢光啦</p>
                  </div>
                </div>
                <div class="flash-tag">免单 x {{item.FreeCardNum}}</div>
                <div class="flash-price"><span>￥</span>0</div>
            </div>
          </div>
        </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
export default {
  name: 'FlashSale',
  props: {
    dataList: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    flashListIndex: {
      type: Number,
      default: 0
    },
    remainTime: {
      type: Number,
      default: 0
    }
  },
  methods: {
    entoDetailPage (productId) {
      this.$emit('entoDetailPage', productId)
    },
    // 全部
    goFlashSaleList () {
      this.$emit('goFlashSaleList', this.flashListIndex)
    }
  }
}
</script>

<style scoped>
  .flash-sale{
    width: 96%;
    margin: 5px auto 0 auto;
    background: #fff;
    border-radius: 8px;
    padding: 5px 10px;
    box-sizing: border-box;
    box-shadow: 0 0 8px 0 #ccc;
    overflow: hidden;
  }
  .flash-sale .mint-swipe{
    height: 6.4rem;
  }
  .flash-title{
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
  }
  .flash-title .all{
    font-size: 14px;
    color: #888;
    cursor: pointer;
  }
  .flash-title .iconfont{
    font-size: 12px;
    vertical-align: middle;
  }
  .flash-sale-list{
    display: flex;
    justify-content: flex-start;
  }
  .flash-sale-list.sp-between{
    justify-content: space-between
  }
  .flash-sale-item{
    position: relative;
    margin-right: 6px;
    flex-grow: 1;
    cursor: pointer;
    max-width: 5.7em;
  }
  .flash-sale-item:last-child{
    margin-right: 0;
  }
  .flash-sale-item .flash-img{
    position: relative;
    height: 74%;
    min-width: 5em;
    min-height: 5em;
  }
  .flash-sale-item .flash-img img{
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 3px;
  }
  .flash-sale-item .flash-tag{
    position: absolute;
    top: 5px;
    padding: 1px 5px;
    font-size: 12px;
    background: #ff0000;
    color: #fff;
    border-radius: 0 10px 10px 0;
  }
  .flash-sale-item .flash-price{
    margin-top: 3px;
    font-size: 15px;
    color: #ff0000;
    font-weight: 500;
  }
  .flash-sale-item .flash-price span{
    font-size: 12px;
  }
  @media screen and (max-width: 320px){
    .flash-sale-item{
      max-width: 4.8em;
    }
    .flash-sale-item .flash-img{
      height: 71.3%;
      min-width: 4em;
      min-height: 4em;
    }
    .flash-sale .mint-swipe{
      height: 5.8rem;
    }
  }
</style>
